import { gql } from '@apollo/client';

import ORGANIZATION_FRAGMENT from '../fragments/organization';

const GET_BASE_ORGANIZATION_QUERY = gql`
  query getBaseOrganization($id: Int!) {
    entity: organization(where: { id: $id }) {
      ...BaseOrganization
    }
  }
  ${ORGANIZATION_FRAGMENT}
`;

export default GET_BASE_ORGANIZATION_QUERY;
